import { DOCUMENT } from '@angular/common';
import { Component, inject, signal } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { RouterOutlet } from '@angular/router';
import { DARK_THEME, DarkThemeService } from '@irohalab/deneb-ui';

@Component({
    selector: 'app-root',
    imports: [RouterOutlet],
    templateUrl: './app.component.html',
    styleUrl: './app.component.less',
    host: {
      '[class.dark-theme]': 'isDarkTheme()'
    }
})
export class AppComponent {
  title = 'mira-identity-provider';

  protected readonly isDarkTheme = signal(false);

  private readonly document = inject(DOCUMENT);
  private readonly darkThemeService = inject(DarkThemeService);

  constructor() {
    this.darkThemeService.themeChange
      .pipe(takeUntilDestroyed())
      .subscribe((theme) => {
        const isDarkTheme = theme === DARK_THEME;
        this.isDarkTheme.set(isDarkTheme);
        this.document.body.classList.toggle('dark-theme', isDarkTheme);
      });
  }
}
